import Vue from 'vue'
import axios from 'axios'
import loadLang from "../utils/loadLang";

let apiBaseUrl = process.env.VUE_APP_BASE_URL
let apiBaseUrlIst = process.env.VUE_APP_BASE_URL_IST


let lang = loadLang.getLang()


Vue.prototype.$http = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        "Accept-Language": `${lang}`,
    }
})

Vue.prototype.$http_ist = axios.create({
    baseURL: apiBaseUrlIst,
})

export const http = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        "Accept-Language": `${lang}`,
    }
})
